import { BaseService } from './base.service';

export type OtpMode = 'email' | 'sms' | 'whatsapp';

export interface CreateLoginOtpPayload {
  send_to: string;
  mode: OtpMode;
  type?: 'member_login';
}

export interface OtpResponse {
  send_to: string;
  mode: OtpMode;
  success: boolean;
}

export class OtpService extends BaseService {
  private static instance = new OtpService();

  private constructor() {
    super('/otp');
  }

  private async createLoginOtpInternal(
    payload: CreateLoginOtpPayload
  ): Promise<OtpResponse> {
    const body = {
      ...payload,
      type: 'member_login' as const,
    };
    try {
      return await this.post<OtpResponse>('/login', body);
    } catch (error: any) {
      const message =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        'Failed to create login OTP';
      throw new Error(message);
    }
  }

  static async createLoginOtp(payload: CreateLoginOtpPayload): Promise<OtpResponse> {
    return this.instance.createLoginOtpInternal(payload);
  }
}
